var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"{{::$ctrl.valueClass}}\"><span ng-transclude=\"\"><span class=\"text-{{::$ctrl.valueColor || 'default'}}\">{{$ctrl.value}}</span> </span><span ng-transclude=\"value\"></span></div><div ng-transclude=\"label\" class=\"{{::$ctrl.labelClass}}\"><small class=\"text-{{::$ctrl.labelColor || 'muted'}}\">{{::$ctrl.label}}</small></div>";
var id1="datum-stacked-inverse.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;